// extracted by mini-css-extract-plugin
export default {"hideWhenNarrow":"RecentlyViewedBanner_hideWhenNarrow__sZqMj"};